module.exports = {"headerColumns":{"firstProduct":"Naam","owner":"Eigenaar","retailer":"Verkoper","productAmount":"Bedrag","productSaleDate":"Verkoopdatum","contractValidityStart":"Geldig vanaf","contractValidityEnd":"Geldig t/m"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/tls-product.json
// module id = 5s5l
// module chunks = 1